'use client';
import dynamic from 'next/dynamic';
import { ComponentType, ImgHTMLAttributes } from 'react';

/*

import MailSVG from 'public/static/svg/premium-mail.svg';
import PhoneSVG from 'public/static/svg/premium-phone.svg';
*/
const iconMapsData = [
  ['audio', dynamic(() => import('public/static/website/svg/audio.svg'))],
  ['envelope', dynamic(() => import('public/static/website/svg/icon-envelope.svg'))],
  ['padlock', dynamic(() => import('public/static/website/svg/icon-padlock.svg'))],
  ['person', dynamic(() => import('public/static/website/svg/icon-person.svg'))],
  ['person-detailed', dynamic(() => import('public/static/website/svg/icon-person-detailed.svg'))],
  ['checkmark', dynamic(() => import('public/static/website/svg/icon-checked.svg'))],
  ['hyphen', dynamic(() => import('public/static/website/svg/icon-hyphen.svg'))],
  ['star', dynamic(() => import('public/static/website/svg/icon-star.svg'))],
  ['star-hollow', dynamic(() => import('public/static/website/svg/icon-star-hollow.svg'))],
  ['check-filled', dynamic(() => import('public/static/website/svg/icon-check-filled.svg'))],
  ['forbidden', dynamic(() => import('public/static/website/svg/icon-forbidden.svg'))],
  ['wire', dynamic(() => import('public/static/website/svg/icon-wire.svg'))],
  ['proforma', dynamic(() => import('public/static/website/svg/icon-proforma-invoice.svg'))],
  ['phone', dynamic(() => import('public/static/website/svg/icon-phone.svg'))],
  ['card', dynamic(() => import('public/static/website/svg/icon-card.svg'))],
  ['chevron-right', dynamic(() => import('public/static/website/svg/icon-chevron-right.svg'))],
  ['phone-premium', dynamic(() => import('public/static/website/svg/premium-phone.svg'))],
  ['mail', dynamic(() => import('public/static/website/svg/icon-mail.svg'))],
  ['question-mark', dynamic(() => import('public/static/website/svg/icon-question-mark.svg'))],
  ['phone-handle', dynamic(() => import('public/static/website/svg/icon-phone-handle.svg'))],
  ['phone-round', dynamic(() => import('public/static/website/svg/premium-phone.svg'))],
  ['mail-round', dynamic(() => import('public/static/website/svg/premium-mail.svg'))],
  ['3-bars', dynamic(() => import('public/static/website/svg/icon-3-bars.svg'))],
  ['dot-i', dynamic(() => import('public/static/website/svg/icon-dot-i.svg'))],
  ['video-triangle', dynamic(() => import('public/static/website/svg/icon-video-triangle.svg'))],
  ['microphone', dynamic(() => import('public/static/website/svg/icon-microphone.svg'))],
  // offer icons
  ['access-to-key-info', dynamic(() => import('public/static/website/svg/offer/access-to-key-info.svg'))],
  ['access-to-library', dynamic(() => import('public/static/website/svg/offer/access-to-library.svg'))],
  ['access-to-webinars', dynamic(() => import('public/static/website/svg/offer/access-to-webinars.svg'))],
  ['competition-advantage', dynamic(() => import('public/static/website/svg/offer/competition-advantage.svg'))],
  [
    'difficult-questions-and-answers',
    dynamic(() => import('public/static/website/svg/offer/difficult-questions-and-answers.svg')),
  ],
  ['early-access', dynamic(() => import('public/static/website/svg/offer/early-access.svg'))],
  ['event-notifications', dynamic(() => import('public/static/website/svg/offer/event-notifications.svg'))],
  ['exclusive-analysis', dynamic(() => import('public/static/website/svg/offer/exclusive-analysis.svg'))],
  ['innovations-within-reach', dynamic(() => import('public/static/website/svg/offer/innovations-within-reach.svg'))],
  ['innovations', dynamic(() => import('public/static/website/svg/offer/innovations.svg'))],
  ['instant-updates', dynamic(() => import('public/static/website/svg/offer/instant-updates.svg'))],
  ['personalized-reports', dynamic(() => import('public/static/website/svg/offer/personalized-reports.svg'))],
  ['process-optimization', dynamic(() => import('public/static/website/svg/offer/process-optimization.svg'))],
  ['reducing-risks', dynamic(() => import('public/static/website/svg/offer/reducing-risks.svg'))],
  ['technological-solutions', dynamic(() => import('public/static/website/svg/offer/technological-solutions.svg'))],
  ['time-saving', dynamic(() => import('public/static/website/svg/offer/time-saving.svg'))],
  ['updates-guarantee', dynamic(() => import('public/static/website/svg/offer/updates-guarantee.svg'))],
  ['weekly-audio-summary', dynamic(() => import('public/static/website/svg/offer/weekly-audio-summary.svg'))],
] as const;

export type IconType = (typeof iconMapsData)[number][0];

export const iconsMap = new Map(iconMapsData) as Map<IconType, ComponentType<ImgHTMLAttributes<SVGElement>>>;

export const Icon = ({
  className,
  icon,
  color,
  size,
}: {
  className?: string;
  icon: IconType;
  color?: string;
  size: string | number;
}) => {
  const IconComponent = iconsMap.get(icon);
  if (!IconComponent) {
    throw new Error(`Icon ${icon} not found`);
  }
  return <IconComponent className={className} style={{ color }} width={size} height={size} />;
};

export const Icons = ({ color, size }) => {
  return (
    <div className="grid w-full grid-cols-4 grid-rows-1 gap-2">
      {[...iconsMap.keys()].map((icon) => (
        <Icon key={icon} icon={icon} color={color} size={size} />
      ))}
    </div>
  );
};
